import { useEffect } from 'react';
import { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import mapVideo from '../../public/assets/videos/investor-rise-bg-map.mp4';
// import { Button } from '@/components/ui/button';
import Logo  from '../../public/assets/images/logo2.png';
import { Link } from 'react-router-dom';

export default function About() {
    const [step, setStep] = useState('initial');
  const [selectedOption, setSelectedOption] = useState('');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


 
  return (
    <div>
     <div className="bg-slate-900">
  {/* Hero Section */}
  <div className="relative md:h-[70vh] h-[40vh] overflow-hidden">
    {/* Background Image with Zoom Out */}
    <motion.div
      initial={{ scale: 1.2 }}
      animate={{ scale: 1 }}
      transition={{ duration: 3, ease: "easeOut" }}
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: "url('/assets/images/about-hero-img.jpg')" }}
    />

    {/* Overlay */}
    <div className="absolute inset-0 bg-black bg-opacity-30" />

    {/* Heading on the Left */}
    <div className="relative z-10 h-full flex items-end sm:items-center justify-start px-5 sm:px-10 pb-10 sm:pb-0">
      <motion.h1
        initial={{ opacity: 0, y: 80 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 2, ease: "easeOut" }}
        className="text-white text-5xl sm:text-4xl md:text-7xl font-semibold bg-black bg-opacity-40 px-4 py-3 sm:px-6 sm:py-6 rounded-xl shadow-xl max-w-[90%] sm:max-w-[70%]"
      >
        About
      </motion.h1>
    </div>
  </div>





  {/* About Page Description */}
  <div className=" text-white relative">
    { /* Background Video */}
      <video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover z-0">
        <source src="/assets/videos/investor-rise-bg-map.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="absolute inset-0 bg-black bg-opacity-35 z-0" />

      <div className="relative z-10">
   

    {/* Info Section */}
    <div className="flex flex-col md:flex-row items-center justify-between px-5 sm:px-10 py-16 max-w-7xl mx-auto gap-10">
      {/* Text Content */}
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 2.2, delay: 0.7 }}
        className="md:w-1/2"
      >
        <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-teal-400">About Us</h2>
        <p className="text-white text-base sm:text-lg leading-relaxed">
         We are a trusted construction and renovation company committed to helping homeowners improve and transform their properties with professional building services. Whether you are planning a modern kitchen renovation, expanding your living space with a house extension, or upgrading your bathroom, our experienced team delivers outstanding results with precision and care.
        </p>

        <p className="text-white text-base sm:text-lg leading-relaxed">
       We understand that every home is unique, which is why we work closely with our clients to provide tailored solutions that match their style, budget, and goals. Our focus is on delivering high-quality craftsmanship, transparent communication, and projects completed to the highest standards.
      
        </p>
                  <button

            className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold bg-teal-500 shadow-xl text-lg group"
          >
            <span className="absolute inset-0 bg-gradient-to-r from-slate-900 to-slate-900 group-hover:from-slate-900 group-hover:to-slate-900 animate-slide-bg transition-all duration-500 ease-in-out"></span>
            <span className="relative z-10">Learn More</span>
          </button>
                </motion.div>

      {/* Image Content */}
      <motion.div
        initial={{ opacity: 0, scale: 1.1 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 2.2, delay: 0.7, ease: "easeOut" }}
        className="md:w-1/2 relative group"
      >
        <div className="relative">
          <div className="overflow-hidden  shadow-2xl">
            <img
              src="/assets/images/about-section-img.png"
              alt="About Us"
              className="w-full h-full object-cover "
            />
          </div>
          {/* Decorative Thick Half Frame */}
          <motion.div
            animate={{ y: [0, -18, 5, 0] }}
            transition={{ repeat: Infinity, duration: 3 }}
            className="absolute top-[-20px] left-[-20px] w-[60px] h-[160px] border-t-[22px] border-l-[22px] border-teal-400"
          ></motion.div>
          <motion.div
            animate={{ y: [0, 18, -5, 0] }}
            transition={{ repeat: Infinity, duration: 3 }}
            className="absolute bottom-[-20px] right-[-20px] w-[60px] h-[160px] border-b-[22px] border-r-[22px] border-teal-400"
          ></motion.div>
           </div>
         </motion.div>
       </div>





     
  </div>


  
</div>




</div>

<div className='bg-white'>
  {/* Info Section */}
<div className="flex justify-center items-center px-4 sm:px-8 py-14 sm:py-20 max-w-7xl mx-auto relative">

{/* Image Content */}
<motion.div
  initial={{ opacity: 0, scale: 1.1 }}
  whileInView={{ opacity: 1, scale: 1 }}
  transition={{ duration: 2.2, delay: 0.7, ease: "easeOut" }}
  className="relative w-full max-w-3xl"
>
  <div className="relative mx-auto h-[300px] sm:h-[500px] overflow-hidden rounded-xl shadow-2xl">
    <motion.img
      src="/assets/images/about-section-img-2.png"
      alt="About Us"
      initial={{ scale: 1.2 }}
      whileInView={{ scale: 1 }}
      transition={{ duration: 3, ease: "easeOut" }}
      className="w-full h-full object-cover"
    />
  </div>

  {/* Responsive Card with Door Animation */}
  <motion.div
  initial={{ clipPath: 'inset(0 100% 0 0)', opacity: 0 }}
  whileInView={{ clipPath: 'inset(0 0% 0 0)', opacity: 1 }}
  transition={{ duration: 1, ease: "easeInOut", delay: 0.5 }}
  className="absolute bottom-[-70px] right-4 sm:right-[-80px] bg-teal-600 text-white shadow-2xl p-6 sm:p-8 w-[90%] sm:w-96 origin-left z-20"
>


  
    <p className="text-base sm:text-xl leading-relaxed">
    Quality Work You Can Trust
    </p>
  </motion.div>
</motion.div>
</div>
</div>

</div>

  
  );
}
